// 1. React
import React from 'react';

// 2. Third-party
import { Modal, Button, Table, Tag, Typography, Alert } from 'antd';

// 3. Constants
import { LIBRARY_FORM_TYPE_COLORS, getLibraryFormTypeLabel } from '@iso/constants/libraryFormTypes';

const { Text } = Typography;

// Shows the outcome of a JSON import: the new forms created, plus any skipped rows.
const ImportResultModal = ({ visible, result, onCancel }) => {
  const created = (result && result.createdForms) || [];
  const skipped = (result && result.skipped) || [];

  const createdColumns = [
    { title: 'Title', dataIndex: 'name', key: 'name' },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 160,
      render: (value) => (value ? <Tag color={LIBRARY_FORM_TYPE_COLORS[value]}>{getLibraryFormTypeLabel(value)}</Tag> : '-'),
    },
    { title: 'Category', dataIndex: 'category', key: 'category', render: (v) => v || '-' },
    { title: 'Sub-category', dataIndex: 'subCategory', key: 'subCategory', render: (v) => v || '-' },
  ];

  const skippedColumns = [
    { title: 'Index', dataIndex: 'index', key: 'index', width: 70 },
    { title: 'Title', dataIndex: 'title', key: 'title', render: (v) => v || '-' },
    { title: 'Reason', dataIndex: 'reason', key: 'reason' },
  ];

  return (
    <Modal
      title="Import Result"
      visible={visible}
      onCancel={onCancel}
      width={1200}
      footer={[
        <Button key="close" type="primary" className="btn-success" onClick={onCancel}>
          Close
        </Button>,
      ]}
    >
      <Alert
        type="success"
        showIcon
        style={{ marginBottom: 12 }}
        message={<Text>{`${created.length} new form(s) created${skipped.length ? `, ${skipped.length} skipped` : ''}`}</Text>}
      />

      <Text strong>New forms created</Text>
      <Table
        rowKey="id"
        size="small"
        style={{ marginTop: 8 }}
        pagination={false}
        columns={createdColumns}
        dataSource={created}
        scroll={{ y: 320 }}
      />

      {skipped.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Text strong>Skipped rows</Text>
          <Table
            rowKey={(row) => `${row.index}`}
            size="small"
            style={{ marginTop: 8 }}
            pagination={false}
            columns={skippedColumns}
            dataSource={skipped}
          />
        </div>
      )}
    </Modal>
  );
};

export default ImportResultModal;
